import React from "react";
import "./RoleSummaryCard.css";

let __elakayInfoSource;
export const __setRoleSummaryCardInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["cardUserActivationModal"]?.[key] || fallback;

// Shared role-limits table + summary card -- used by CardUser's activation
// modal (previous/requested role comparison) and addAdminFamily's
// SuccessResultCard (mission 1.2: "afficher les données correspondant au
// rôle sélectionné", never a hardcoded/fixed role's limits). Always driven
// by the roleData actually passed in -- never a stale/default role.
const ROLE_LIMIT_KEYS = [
  { key: "maxRoyalite", nameKey: "t007", fallback: "Royalty" },
  { key: "maxSeller", nameKey: "t008", fallback: "Maximum Sellers" },
  { key: "maxProducer", nameKey: "t009", fallback: "Maximum Producers" },
  { key: "maxAssociate", nameKey: "t010", fallback: "Maximum Associates" },
  { key: "maxAdmin", nameKey: "t011", fallback: "Maximum Admins" },
  { key: "maxInvestment", nameKey: "t012", fallback: "Maximum Investments" },
];

// Kept as its own small function (mission: "Continuer à utiliser
// UserRoleLimits(roleData) si cette fonction est correcte, mais sécuriser
// ses paramètres") -- same table shape as before, just null-safe.
export const RoleLimitsTable = (roleData) => {
  const safeRoleData = roleData && typeof roleData === "object" ? roleData : {};
  return (
    <table className="carduser-role-summary-table">
      <thead>
        <tr>
          <th>{__elakayText("t013", "Role Limit")}</th>
          <th>{__elakayText("t014", "Value")}</th>
        </tr>
      </thead>
      <tbody>
        {ROLE_LIMIT_KEYS.map(({ key, nameKey, fallback }) => (
          safeRoleData[key] > 0 && (
            <tr key={key}>
              <td>{__elakayText(nameKey, fallback)}</td>
              <td>{safeRoleData[key]}</td>
            </tr>
          )
        ))}
      </tbody>
    </table>
  );
};

const RoleSummaryCard = ({ variant, roleData }) => {
  if (!roleData || typeof roleData !== "object") return null;
  const isPrevious = variant === "previous";
  return (
    <div className={`carduser-role-summary carduser-role-summary--${variant}`}>
      <div className="carduser-role-summary-heading">
        <span className="carduser-role-summary-tag">
          {isPrevious ? __elakayText("t015", "Previous role") : __elakayText("t016", "Requested role")}
        </span>
        <h4>{roleData.roleName || "—"}</h4>
      </div>
      {RoleLimitsTable(roleData)}
    </div>
  );
};

export default RoleSummaryCard;
